import React from "react";
import "./style.css";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import GameIcon from "../../../../assets/game-icon.svg";
import MeetingIcon from "../../../../assets/meeting-icon.svg";
import TestIcon from "../../../../assets/test-icon.svg";
import VideocallIcon from "../../../../assets/videocall-icon.svg";
import GroupcallIcon from "../../../../assets/videoconference-icon.svg";
import MusicoboIcon from "../../../../assets/musicobo-icon.svg";
import ScoboIcon from "../../../../assets/scobo-icon.svg";
import Gars2Icon from "../../../../assets/gars2-icon.svg";
import Gars3Icon from "../../../../assets/gars3-icon.svg";
import Asq3Icon from "../../../../assets/asq3-icon.svg";
import Wisc4Icon from "../../../../assets/wisc4-icon.svg";
import PanelIcon from "../../../../assets/mehrobopanel-icon.svg";
import SendIcon from "../../../../assets/send-icon.svg";
import UserIcon from "../../../../assets/user-icon.svg";
import BotIcon from "../../../../assets/bot-icon.svg";

import BalanceIcon from "../../../../assets/balance-icon.svg";

import { MdOutlineDashboard } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
import { AiOutlineEdit, AiOutlineSend } from "react-icons/ai";
import { PiUserList, PiClipboardTextBold } from "react-icons/pi";
import { IoGameControllerOutline } from "react-icons/io5";
import EditPersonalInfoModal from "./personalInfo-modal";
import { fontSize } from "@mui/system";
import ExpiredPanelModal from "./expiredpanel-modal";
import QuickPurchaseModal from "./quickparchase-modal";
import PaymentCheckoutModal from "./paymentcheckout-modal";

const faNumbers = require("../../../../utils/numbersFa.js");

class DashboardEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accessType: props.selectedUser.access,
      activeTests: props.selectedUser.activeevaluations,
      registerTime: props.selectedUser.registertime,
      email: null,
      firstName: props.selectedUser.firstname,
      lastName: props.selectedUser.lastname,
      farsiNumbers: faNumbers,
      isLogin: false,
      userId: props.selectedUser.id,
      products: props.selectedUser.products,
      sendMessage: "Hello,I'mInDashboardPage",
      openEditModal: false,
      openExpiredModal: false,
      openPurchaseModal: false,
      openCheckoutModal: false,
      paymentStatus: false,
      paymentTrackId: "",
      showPurchaseButton: true,
      typedMessage: "",
      remainedDays: 0,
      isLoaded: false,
    };
  }

  componentDidMount = async () => {
    this.handleRedirect();
    this.checkPayment();

    const dateCorrectedFormat = this.state.products.Panel.replaceAll("-", "/"); // For ios!
    const remainedAccountInDays = Math.floor(
      (new Date(dateCorrectedFormat) - new Date()) / (1000 * 60 * 60 * 24)
    );
    const regiCorrectedFormat = this.state.registerTime.replaceAll("-", "/"); // For ios!
    const registeredSeconds = Math.floor(
      (new Date() - new Date(regiCorrectedFormat)) / 1000
    );

    this.setState({ remainedDays: remainedAccountInDays });
    this.setState({ openExpiredModal: remainedAccountInDays < 0 });
    this.setState({ isLoaded: true });
    console.log("seconds:", registeredSeconds);
    console.log("active tests:", this.state.activeTests);
    if (this.state.accessType == "User" && registeredSeconds < 60) {
      this.setState({ openPurchaseModal: true });
    }
    if (
      (this.state.accessType == "User" && this.state.products.Scobo != 0) ||
      this.state.accessType == "Clinic" ||
      this.state.accessType == "Therapist"
    ) {
      this.setState({ showPurchaseButton: false });
    }
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  async checkPayment() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const paymentSuccess = params.get("success");
    const paymentStatus = params.get("status"); // 1: Paid and verified successfully, 2: Paid but not verified, 3: Canceled by user
    const paymentTrackId = params.get("trackId");

    console.log("debbb1", paymentSuccess, paymentStatus, paymentTrackId);
    if (
      paymentSuccess == null &&
      paymentStatus == null &&
      paymentTrackId == null
    ) {
      return;
    } else {
      this.setState({ openCheckoutModal: true });
    }
  }

  editModalHandler = (modal) => {
    this.setState({ openEditModal: modal });
    this.setState({ openPurchaseModal: modal });
  };

  engToFarsiCurrency = (price) => {
    var priceString = price.toString();
    var priceLength = price.toString().length;
    var farsiPrice = "";
    for (let i = 0; i < priceLength; i++) {
      if (i != 0 && i % 3 == 0) {
        farsiPrice = "٫" + farsiPrice;
      }
      var nextDigit = parseInt(priceString[priceLength - i - 1]);
      farsiPrice = this.state.farsiNumbers[nextDigit] + farsiPrice;
    }

    return farsiPrice;
  };

  buttonStartSession = async (audId, test) => {
    const response = await axios.post(
      "https://request.kidiar.com/evaluation/start",
      { audienceId: audId, testName: test },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 1 && test == "SCOBO")
      window.location.href = "/en/panel/evaluations/scobo";
    if (response.data.status == 1 && test == "GARS2")
      window.location.href = "/fa/panel/evaluations/gars2";
    if (response.data.status == 1 && test == "GARS3")
      window.location.href = "/fa/panel/evaluations/gars3";
    if (response.data.status == 1 && test == "ASQ3")
      window.location.href = "/fa/panel/evaluations/asq3";
    if (response.data.status == 1 && test == "WISC4")
      window.location.href = "/fa/panel/evaluations/wisc4";
  };

  render() {
    if (this.state.isLoaded == false) {
      return <div className="container-fluid"></div>;
    }

    return (
      <div className="panel-home-page">
        {this.state.openExpiredModal && <ExpiredPanelModal />}
        {this.state.openEditModal && (
          <EditPersonalInfoModal
            closeModal={(modalBool) => this.editModalHandler(modalBool)}
            selectedUser={this.props.selectedUser}
          />
        )}
        {this.state.openPurchaseModal && (
          <QuickPurchaseModal
            closeModal={(modalBool) => this.editModalHandler(modalBool)}
            selectedUser={this.props.selectedUser}
          />
        )}
        {this.state.openCheckoutModal && (
          <PaymentCheckoutModal
            closeModal={(modalBool) => this.editModalHandler(modalBool)}
          />
        )}
        <div className="dashboard-title-container">
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column">
              <p className="font-medium font-18 mode-text-2 mb-3">Dashboard</p>
              <span className="font-light font-14 mode-text-3">
                Welcome to {this.state.firstName} profile!
              </span>
            </div>
            {/* <a className='d-flex justify-content-between align-items-center panel-card pb-4 pr-4 py-4' style={{minWidth: '26.5%'}}>
                            <p className='font-medium font-18 mode-text-1 mb-3'>اعتبار</p>
                            <span className='font-light font-14 mode-text-4'>{this.engToFarsiCurrency(this.state.products.Balance)} {"تومان"}</span>
                        </a> */}
          </div>
        </div>
        <div className="panel-home-page-content">
          <a
            className="home-item-2 panel-card pb-4 pr-4 py-4"
            onClick={() =>
              this.setState({ openEditModal: !this.state.openEditModal })
            }
          >
            <div className="item-content">
              <div
                className="d-flex justify-content-center align-items-center font-28 mode-text-1"
                style={{
                  background: "#fff1e6",
                  color: "#f7931e",
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                }}
              >
                <PiUserList></PiUserList>
              </div>
              <div className="label-item-description d-flex flex-column mr-3">
                <div className="d-flex align-items-center font-13 mode-text-1">
                  <p className="" style={{ minWidth: "150px" }}>
                    Information
                  </p>
                  <AiOutlineEdit
                    style={{ minWidth: "100px", fontSize: "1.5em" }}
                  ></AiOutlineEdit>
                </div>
                <div className="d-flex mode-text-4">
                  <p
                    className="font-13"
                    style={{ minWidth: "150px", marginLeft: "15px" }}
                  >
                    {"Email: "}
                    {this.state.email}
                  </p>
                  <p
                    className="font-13"
                    style={{ minWidth: "100px", marginLeft: "15px" }}
                  >
                    {"User: "}
                    {(this.state.accessType === "User" && "Child") ||
                      (this.state.accessType === "Therapist" && "Therapist") ||
                      (this.state.accessType === "Clinic" && "Manager")}
                  </p>
                </div>
              </div>
            </div>
          </a>
          {/* {this.state.accessType !== "User" &&
                    <a href='/fa/panel/sessions' className='home-item-2 panel-card pb-4 pr-4 py-4'>
                        <div className='item-content'>
                            <div className='label-item-icon d-flex' style={{background: '#ffccdd', color: '#ff0054', justifyContent: 'center', alignItems: 'center', fontSize: '28px'}}>
                                <HiOutlineUserGroup alt='icon-panel'></HiOutlineUserGroup>
                            </div>
                            <div className='label-item-description d-flex flex-column mr-3'>
                                <p className='font-13 mode-text-1'>جلسات آنلاین</p>
                                <div className='d-flex'>
                                    <img src={VideocallIcon} alt='icon-scobo' style={{width:'30px', marginLeft:'5px'}}></img>
                                    <p className='font-13 mode-text-4' style={{marginLeft:'15px'}}>{this.state.farsiNumbers[this.state.products.Videocall]}</p>
                                </div>
                            </div>
                        </div>
                    </a>
                    } */}
          <a className="home-item-3 panel-card pb-4 pr-4 py-4">
            <div className="item-content">
              <div
                className="label-item-icon d-flex"
                style={{
                  background: "#ebffeb",
                  color: "#00ff06",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "28px",
                }}
              >
                <PiClipboardTextBold alt="icon-panel"></PiClipboardTextBold>
              </div>
              <div className="label-item-description d-flex flex-column mr-3">
                <p className="font-13 mode-text-1">Tests and Evaluations</p>
                <div
                  className="d-flex"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
                  }}
                >
                  <img
                    src={ScoboIcon}
                    alt="icon-scobo"
                    style={{ width: "30px", marginLeft: "5px" }}
                  ></img>
                  <p
                    className="font-13 mode-text-4"
                    style={{ marginLeft: "15px" }}
                  >
                    {this.state.products.Scobo}
                  </p>
                  {this.state.accessType !== "User" && (
                    <img
                      src={Gars2Icon}
                      alt="icon-gars2"
                      style={{ width: "30px", marginLeft: "5px" }}
                    ></img>
                  )}
                  {this.state.accessType !== "User" && (
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {this.state.products.Gars2}
                    </p>
                  )}
                  {this.state.accessType !== "User" && (
                    <img
                      src={Gars3Icon}
                      alt="icon-gars2"
                      style={{ width: "30px", marginLeft: "5px" }}
                    ></img>
                  )}
                  {this.state.accessType !== "User" && (
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {this.state.products.Gars3}
                    </p>
                  )}
                  {this.state.accessType !== "User" && (
                    <img
                      src={Asq3Icon}
                      alt="icon-gars2"
                      style={{ width: "30px", marginLeft: "5px" }}
                    ></img>
                  )}
                  {this.state.accessType !== "User" && (
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {this.state.products.Asq3}
                    </p>
                  )}
                  {this.state.accessType !== "User" && (
                    <img
                      src={Wisc4Icon}
                      alt="icon-gars2"
                      style={{ width: "30px", marginLeft: "5px" }}
                    ></img>
                  )}
                  {this.state.accessType !== "User" && (
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {this.state.products.Wisc4}
                    </p>
                  )}
                </div>
              </div>
            </div>
            {this.state.accessType !== "User" && (
              <div className="item-content">
                <div
                  className="label-item-icon d-flex"
                  style={{
                    background: "#d1ecfc",
                    color: "#008cff",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "28px",
                  }}
                >
                  <MdOutlineDashboard alt="icon-panel"></MdOutlineDashboard>
                </div>
                <div className="label-item-description d-flex flex-column mr-3">
                  <p className="font-13 mode-text-1">Remained Account</p>
                  <div className="d-flex">
                    <img
                      src={PanelIcon}
                      alt="icon-scobo"
                      style={{ width: "30px", marginLeft: "5px" }}
                    ></img>
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {this.state.remainedDays}
                    </p>
                    <p
                      className="font-13 mode-text-4"
                      style={{ marginLeft: "15px" }}
                    >
                      {"Days"}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {this.state.showPurchaseButton && (
              <div className="item-button">
                <button
                  style={{
                    width: "96px",
                    height: "24px",
                    color: "#fff",
                    backgroundImage: "linear-gradient(180deg,#FF0073,#D81B60)",
                    border: "none",
                    borderRadius: "6px",
                  }}
                  onClick={() => this.setState({ openPurchaseModal: true })}
                >
                  {"take a Test"}
                </button>
              </div>
            )}
          </a>
          <div className="home-item-1 pb-4">
            <div className="test-table-header d-flex align-items-center mode-bg-5 pr-4 pl-4">
              <p className="mode-text-9 w-15 ">Row</p>
              <p className="mode-text-9 w-25 ">User</p>
              <p className="mode-text-9 w-35 ">Test</p>
            </div>
            {this.state.activeTests.length == 0 && (
              <p className="pr-4 mode-text-0">
                You don't have any active test ...
              </p>
            )}
            {this.state.activeTests.map((activeTest, i) => (
              <div className="table-row" key={i}>
                <a className="test-table-row w-100 d-flex align-items-center mode-bg-9 pr-4 pl-4">
                  <p className="mode-text-7 w-15">{i + 1}</p>
                  <p className="mode-text-7 w-40">
                    {this.state.firstName} {this.state.lastName}
                  </p>
                  {activeTest.session == "SCOBO" && (
                    <p className="mode-text-7 w-45">Autism Screening</p>
                  )}
                  {activeTest.session == "ASQ3" && (
                    <p className="mode-text-7 w-45">Ages Screening</p>
                  )}
                </a>
                <a
                  className="sbt-btn mode-bg-3 mode-text-0"
                  onClick={() =>
                    this.buttonStartSession(
                      activeTest.audience,
                      activeTest.session
                    )
                  }
                >
                  <div>Enter</div>
                </a>
              </div>
            ))}
          </div>
          <a className="home-item-4 panel-card pb-4 pr-4 py-4">
            <div className="item-content">
              <div
                className="label-item-icon d-flex"
                style={{
                  background: "#ffccdd",
                  color: "#ff0054",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "28px",
                }}
              >
                <IoGameControllerOutline alt="icon-panel"></IoGameControllerOutline>
              </div>
              <div className="label-item-description d-flex flex-column mr-3">
                <p className="font-13 mode-text-1">Game Accounts</p>
                <div className="d-flex">
                  <img
                    src={MusicoboIcon}
                    alt="icon-scobo"
                    style={{ width: "30px", marginLeft: "5px" }}
                  ></img>
                  <p
                    className="font-13 mode-text-4"
                    style={{ marginLeft: "15px" }}
                  >
                    {this.state.products.Musicobo}
                  </p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

export default DashboardEn;
